import { render, staticRenderFns } from "./UploadV2.vue?vue&type=template&id=5ed9b749&scoped=true"
import script from "./UploadV2.vue?vue&type=script&lang=js"
export * from "./UploadV2.vue?vue&type=script&lang=js"
import style0 from "./UploadV2.vue?vue&type=style&index=0&id=5ed9b749&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed9b749",
  null
  
)

export default component.exports